import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsAddTradingResolverErrorStatesEnum {
    GetTradingPlatformsFailed = ErrorStateScheduleEnum.PanelAccountsAddTradingResolverStatesStartIndex,
    TradingPlatformsNotFound,
    GetCashAccountFailed,
    CashAccountNotFound,
    GetClearingAgentsFailed,
    GetClearingAgentsNotFound,
    GetClearingAgentsActiveNotFound,
    GetCurrenciesNotFound,
    GetOmsRiskParametersFailed,
    GetOmsRiskParametersNotFound

}
